var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTableSortArrow = function SvgTableSortArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.354 4.646a.5.5 0 00-.708 0L8.464 7.828a.5.5 0 10.708.708L12 5.707l2.828 2.829a.5.5 0 10.708-.708l-3.182-3.182zM12.5 19V5h-1v14h1z"
  })));
};
export default SvgTableSortArrow;